module.exports = __webpack_public_path__ + "images/jtautolease_smallfb903cf58d87f2c03e6005e4af44446c.png";